import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { appRouter } from "./app/router";
import "./index.css";
import { initSentry, Sentry } from "./lib/sentry";
import { installMaterialSymbolTranslationGuard } from "./lib/materialSymbolTranslationGuard";
import { preloadInitialLocale } from "./i18n";

// Sentry vor allem anderen — no-op wenn VITE_SENTRY_DSN fehlt.
initSentry();

// Material Symbols are text ligatures (`visibility`, `close`, ...). Protect
// them before React mounts so Chrome's automatic translation cannot turn icon
// tokens into visible copy. The observer also covers lazy-loaded routes.
const disconnectMaterialSymbolTranslationGuard = installMaterialSymbolTranslationGuard();

if (import.meta.hot) {
  import.meta.hot.dispose(disconnectMaterialSymbolTranslationGuard);
}

async function bootstrap() {
  // Load only the active catalog, but do so before mounting to avoid a
  // translation flash or a second render during startup.
  await preloadInitialLocale();

  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Application root is missing");
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <RouterProvider router={appRouter} />
    </React.StrictMode>,
  );
}

function renderBootstrapError(error) {
  Sentry.captureException(error);
  const rootElement = document.getElementById("root");
  if (!rootElement) return;
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <main className="grid min-h-screen place-items-center bg-surface p-6 text-on-surface">
      <section
        role="alert"
        className="w-full max-w-md rounded-xl border border-outline bg-surface-container p-6 shadow-lg"
      >
        <h1 className="text-lg font-semibold">Customy konnte nicht geladen werden</h1>
        <p className="mt-2 text-sm text-on-surface-variant">
          Ein benötigter App-Baustein fehlt oder ist veraltet. Lade die Seite neu, um die aktuelle
          Version abzurufen.
        </p>
        <button
          type="button"
          className="mt-5 min-h-11 rounded-lg bg-primary px-4 font-semibold text-on-primary"
          onClick={() => window.location.reload()}
        >
          Seite neu laden
        </button>
      </section>
    </main>,
  );
}

void bootstrap().catch(renderBootstrapError);
